import { useEffect } from 'react';
import { Text } from '@fluentui/react-components';

export default function SettingsLocale() {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('setPageContext', {
      detail: { title: 'Translations' },
    }));
    return () => {
      window.dispatchEvent(new CustomEvent('setPageContext', { detail: null }));
    };
  }, []);

  return (
    <div style={{ padding: '1rem' }}>
      <Text>Configure translation settings here.</Text>
    </div>
  );
}
